import { environment } from "src/environments/environment";

declare var require: any;
var domain = require("src/assets/appdomain.json");
export class AppUrlsService {
  //Cloud Domain
  // public DOMAIN: string = domain.domainLink + "platform";
  //Onstak Domain
  //  public DOMAIN: string = `http://192.198.218.58`;
  // public IDENTITY_LINK: string = `${domain.domainLink}identity`;
  // public DOMAIN: string = `https://api.onstak.io`;
public DOMAIN: string = `https://apis.onstak.ai`;
  // public IDENTITY_LINK: string = `${this.DOMAIN}/services/identity`;
  public IDENTITY_LINK: string = `${environment.IDENTITY}`;
  public CORE_LINK: string = `${environment.DOMAIN}`;
  // public MERAKI_URL:string = `https://api.meraki.com`;
  public MERAKI_URL: string = `${environment.MERAKI}`;
  // public CORE_LINK: string = `${this.DOMAIN}`;
  // public CORE_LINK_cdn: string = `${this.DOMAIN}services/platform/`;
  // public SOCKET_LINK: string = `${this.DOMAIN}`;
  // public CORE_LINK_cdn: string = `${environment.DOMAIN}services/platform/`;
  public CORE_LINK_cdn: string = `${environment.DOMAIN}/`;
  public SOCKET_LINK: string = `${environment.DOMAIN}`;
  public MQTT_LINK: string = `http://event-hub.dev.onstak.io:8080`;
  videDomain = "http://192.198.218.57:8084";

  getVideoAgentApiUrl(): string {
    return `${this.CORE_LINK}/api/video-agent`;
  }
}
